module.exports = __webpack_public_path__ + "static/media/separator.58444d43.png";